import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import Message from "../../../Components/Message";

const CashHandoversModal = ({
  show,
  handleClose,
  mode,
  paymentData,
  staff,
  handleSubmit,
  error,
  setError
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    employee: "",
    amount: "",
    notes: "",
    type: "withdraw"
  });

  useEffect(() => {
    if (paymentData) {


      const employeeId = staff?.find(s => s.name === paymentData.employee)?.id || "";
      const transactionType = paymentData.type ? String(paymentData.type) : "withdraw";

      setFormData({
        employee: employeeId || "",
        amount: paymentData.amount || "",
        notes: paymentData.notes || "",
        type: transactionType,
      });
    } else {
      setFormData({
        employee: "",
        amount: "",
        notes: "",
        type: "withdraw",
      });
    }
  }, [paymentData, staff, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.employee) {
      setError("يرجى اختيار الموظف");
      return false;
    }
    if (!formData.amount || isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
      setError("يرجى إدخال مبلغ صحيح");
      return false;
    }
    return true;
  };

  const onSubmit = async () => {
    if (validateForm()) {
      setIsSubmitting(true);
      const success = await handleSubmit(formData);
      if (success) {
        setError(null);
      }
      setIsSubmitting(false);
    }
  };


  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="modal-container flex-column-reverse" closeButton>
        <Modal.Title>
          {mode === "add" ? "إضافة" : "تعديل"} تسليم نقدي
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Message variant="danger">{error}</Message>}
        <Form>
          {/* Employee Dropdown */}
          <Form.Group className="mb-3" controlId="employee">
            <Form.Label>الموظف</Form.Label>
            <Form.Select
              name="employee"
              value={formData.employee}
              onChange={handleChange}
              required
            >
              <option value="">اختر الموظف...</option>
              {staff?.map((employee) => (
                <option key={employee.id} value={employee.id}>
                  {employee.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Amount Input */}
          <Form.Group className="mb-3" controlId="amount">
            <Form.Label>المبلغ</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="أدخل المبلغ"
              required
              dir="ltr"
              style={{ textAlign: "right" }}
            />
          </Form.Group>

          {/* Notes Input */}
          <Form.Group className="mb-3" controlId="notes">
            <Form.Label>ملاحظات (اختياري)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes || ""}
              onChange={handleChange}
              placeholder="ملاحظات إضافية..."
            />
          </Form.Group>
          
          {/* Transaction Type Selection */}
          <Form.Group className="mb-3" controlId="type">
            <Form.Label>نوع العملية</Form.Label>
            <div className="d-flex">
              <Form.Check
                type="radio"
                label="سحب"
                name="type"
                id="withdraw"
                value="withdraw"
                checked={formData.type === "withdraw"}
                onChange={handleChange}
                className="ms-4"
              />
              <Form.Check
                type="radio"
                label="إيداع"
                name="type"
                id="deposit"
                value="deposit"
                checked={formData.type === "deposit"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
          إلغاء
        </Button>
        <Button variant="primary" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              جارٍ المعالجة...
            </>
          ) : (
            mode === "add" ? "إضافة" : "تعديل"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CashHandoversModal;